import { VoucherFilterControls, type VoucherSortOrder } from '@/components/vouchers/VoucherFilterControls';
import React from 'react';

type VoucherFilterBarProps = {
  selectedCategory: string;
  searchQuery: string;
  onCategoryChange: (category: string) => void;
  onSearchChange: (query: string) => void;
  sortOrder: VoucherSortOrder;
  onSortChange?: (order: VoucherSortOrder) => void;
};

export const VoucherFilterBar: React.FC<VoucherFilterBarProps> = ({
  selectedCategory,
  searchQuery,
  onCategoryChange,
  onSearchChange,
  sortOrder,
  onSortChange,
}) => {
  return (
    <VoucherFilterControls
      selectedCategory={selectedCategory}
      searchQuery={searchQuery}
      onCategoryChange={onCategoryChange}
      onSearchChange={onSearchChange}
      sortOrder={sortOrder}
      onSortChange={onSortChange}
    />
  );
};

export default VoucherFilterBar;
